export const offerValue = {
    "group": "job",
    "subGroup": {
        "information": "information",
        "targetCountry": "targetCountry"
    },
    "field": {
        "uuid": "uuid",
        "title": "jobTitle",
        "company": "company",
        "jobType": "jobType",
        "workPlace": "workplace",
        "location": "location",
        "description": "description",
        "requirement": "requirement",
        "salary": "salaryRange",
        "status": "status",
        "tag": "tag",
        "recruiter": "recruiter",
        "category": "category",
        "targetCountryMG": "targetCountryMG",
        "targetCountryIN": "targetCountryIN",
        "targetCountryAFRICA": "targetCountryAFRICA",
        "recruiterEmail": "recruiterEmail"
    }
}